export class MigrationBase {
  protected $store: any
  protected $route: any
  protected idx: number = 0
  protected siteRef: any = null

  async runMigration(): Promise<any> {}

  async onCompleted() {}
  async beforeMigration(): Promise<any> {}

  setStore(idx: number, store: any, route?: any, siteRef?: any) {
    this.$store = store
    this.$route = route
    this.idx = idx
    this.siteRef = siteRef
  }

  async waitForAWhile(ms: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, ms)
    })
  }

  /**
   * Set the migration log message
   * @param message - The message to set as the current log
   */
  setMessageLog(message: string) {
    if (this.$store) {
      this.$store.dispatch('migration/setMessageLog', `${this.idx} - ${message}`)
    }
  }

  /**
   * Clear the migration log message
   */
  clearMessageLog() {
    if (this.$store) {
      this.$store.dispatch('migration/clearMessageLog')
    }
  }
}
